export const endpoints = {
  ORGANIZATION_STATISTICS: "/organization/statistics",
}